import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import {
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    IconButton,
    Stack,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import { Link } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { validatePhone } from '../../utils/regex/Regex';
import { initUsersData } from '../../utils/object/Signin';
import { useNavigate } from 'react-router-dom';
import { openLoadingApi, closeLoadingApi } from '../../redux/create-actions/LoadingAction';
import LoginIcon from '@mui/icons-material/Login';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { openChangePassModal, unLoad } from '../../redux/create-actions/ChangePassAction';
import Color from '../../layouts/Color';
import FontSize from '../../layouts/FontSize';
import { graphCustomerLogin } from '../../services/Authenticate';
import Storage from '../../services/Storage';

const registerButton = {
    bgcolor: Color.Main,
    borderRadius: '30px',
    boder: '1px solid',
    fontWeight: '500',
    textAlign: 'center',
    padding: '10px 30px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': {background: Color.Button, color: Color.Normal}
};

const navbar = { 
    fontWeight: 600, 
    fontSize: FontSize.Big,  
    color: Color.Sub 
};

const logo = { 
    fontWeight: 600, 
    fontSize: FontSize.Big,  
    color: Color.Main 
};

const forgot = {
    textAlign: 'left',
    color: Color.Main,
    textDecoration: 'none',
    fontSize: FontSize.Medium,
}

const submit = {
    bgcolor: Color.Main,
    borderRadius: '30px',
    boder: '1px solid',
    fontWeight: '500',
    textAlign: 'center',
    padding: '10px 80px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': {background: Color.Button, color: Color.Normal}
}

function AuthLogin() {
    const theme = useTheme();
    const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
    const [checked, setChecked] = useState(true);
    const [phoneErrorText, setPhoneErrorText] = useState('');
    const [passwordErrorText, setPasswordErrorText] = useState('');
    const [login, setLogin] = useState(initUsersData('', ''));
    let navigate = useNavigate();

    const dispatch = useDispatch();
    const data = useSelector(state => state.first.data);

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleChangePhone = (event) => {
        let value = event.target.value;
        handleValidatePhone(value);
    }

    const handleChangePassword = (event) => {
        let value = event.target.value;
        handleValidatePassword(value);
    }

    function handleValidatePhone(phone) {
        let result = validatePhone(phone);
        let data;
        if (!result) {
            data = { ...login, phone: phone, isPhoneError: true };
            setLogin(data);
            setPhoneErrorText("Error Phone Format");
        } else {
            data = { ...login, phone: phone, isPhoneError: false };
            setLogin(data);
            setPhoneErrorText("");
        }
        return data;
    }

    function handleValidatePassword(password) {
        let data;
        if (password === "") {
            data = { ...login, password: password, isPasswordError: true };
            setLogin(data);
            setPasswordErrorText("Error Password Format");
        } else {
            data = { ...login, password: password, isPasswordError: false };
            setLogin(data);
            setPasswordErrorText("");
        }
    }

    useEffect(() => {
        if(data.load === true) {
            navigate("/dashboard", { replace: true });
            dispatch(unLoad())
        }
    },[data.load, navigate, dispatch])

    const handleSubmit = (e) => {
        e.preventDefault()
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: '',
        };
        if ((!login.isPhoneError && !login.isPasswordError) && login.phone !== "" && login.password !== "") {
            dispatch(openLoadingApi());
            let promise = graphCustomerLogin(login.phone, login.password);
            promise.then(result => {
                    dispatch(closeLoadingApi());
                    if (result.isFirstLogin === true) {
                        dispatch(openChangePassModal(result))
                    }
                    else {
                        Storage.updateLocalAccessToken(result.accessToken.token);
                        Storage.updateLocalRefreshToken(result.refreshToken.token);
                        Storage.updateLocalProfile(JSON.stringify(result.customer));
                        alert = { ...alert, message: "Login successful!", severity: 'success', title: 'Success' };
                        dispatch(showAlert(alert));
                        navigate("/dashboard", { replace: true });
                    }
            }).catch(function (error) {
                const err = JSON.parse(JSON.stringify(error))
                alert = { ...alert, message: err.response.errors[0].message };
                dispatch(closeLoadingApi());
                dispatch(showAlert(alert));
            });
        } else {
            alert = { ...alert, message: "You need to input correct your phone and password!" };
            dispatch(showAlert(alert))
        }
    }

    return (
        <div>
            <header className="header-section register login">
                <div className="overlay">
                    <div className="container">
                        <div className="row d-flex header-area">
                            <nav className="navbar d-flex justify-content-between navbar-expand-lg navbar-dark">
                                <Link className="navbar-brand" to="/" style={navbar}>
                                    <span className="logo-home" />APO<span style={logo}>LLO</span>
                                </Link>
                                <div className="d-flex align-items-center justify-content-end">
                                    <div className="right-area header-action d-flex align-items-center">
                                        <Button
                                            variant="contained"
                                            component={Link}
                                            to={'/signup'}
                                            endIcon={<AppRegistrationIcon />}
                                            sx={registerButton}
                                        >
                                            Register
                                        </Button>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
            <section className="sign-in-up login">
                <div className="overlay pb-120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="form-content">
                                    <div className="section-header">
                                        <h5 className="sub-title">Give yourself the Bankio Edge</h5>
                                        <h2 className="title">Login Now</h2>
                                    </div>
                                    <Grid component="form" container direction="column" spacing={2}>
                                        <Grid item container spacing={3} justifyContent="center">
                                            <Grid item xs={8}>
                                                <TextField
                                                    required
                                                    id="phone"
                                                    name="phone"
                                                    label="Phone Number"
                                                    fullWidth
                                                    variant="outlined"
                                                    autoComplete="phone"
                                                    error={login.isPhoneError}
                                                    helperText={phoneErrorText}
                                                    onChange={handleChangePhone}
                                                    size={matchDownMD ? 'small' : "medium"}
                                                    sx={{
                                                        '& .MuiInputBase-input': {
                                                            bgcolor: theme.palette.background.default
                                                        },
                                                        '& .MuiOutlinedInput-root': {
                                                            bgcolor: theme.palette.background.default
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={8}>
                                                <TextField
                                                    required
                                                    id="password"
                                                    name="password"
                                                    type={showPassword ? 'text' : 'password'}
                                                    label="Password"
                                                    fullWidth
                                                    variant="outlined"
                                                    autoComplete="password"
                                                    error={login.isPasswordError}
                                                    helperText={passwordErrorText}
                                                    onChange={handleChangePassword}
                                                    size={matchDownMD ? 'small' : "medium"}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleClickShowPassword}
                                                                onMouseDown={handleMouseDownPassword}
                                                                edge="end"
                                                                size={matchDownMD ? "small" : "medium"}
                                                            >
                                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                                            </IconButton>
                                                        )
                                                    }}
                                                    sx={{
                                                        '& .MuiInputBase-input': {
                                                            bgcolor: theme.palette.background.default
                                                        },
                                                        '& .MuiOutlinedInput-root': {
                                                            bgcolor: theme.palette.background.default
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={8}>
                                                <Stack direction="row" alignItems="center" justifyContent="space-around" spacing={1}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={checked}
                                                                onChange={(event) => setChecked(event.target.checked)}
                                                                name="checked"
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Remember me"
                                                    />
                                                    <Typography variant="subtitle1" color="secondary">
                                                        <Link
                                                            to="/forgot-pass"
                                                            style={forgot}
                                                        >
                                                            Forgot password?
                                                        </Link>
                                                    </Typography>
                                                </Stack>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="btn-area">
                                                    <Button
                                                        onClick={handleSubmit}
                                                        type="submit"
                                                        variant="contained"
                                                        sx={submit}
                                                        endIcon={<LoginIcon />}
                                                    >
                                                        Sign In
                                                    </Button>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AuthLogin;
